import * as types from "../types/index";
import { core } from "./core";

export const getDashboardBlocks = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/${queryString ? `?${queryString}` : ""}`,
    types.GET_DASHBOARD_BLOCKS,
    types.GET_DASHBOARD_BLOCKS_SUCCESS,
    types.GET_DASHBOARD_BLOCKS_FAILURE
  );
};

export const getHoursByUser = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/hours-by-user/${queryString ? `?${queryString}` : ""}`,
    types.GET_HOURS_BY_USER,
    types.GET_HOURS_BY_USER_SUCCESS,
    types.GET_HOURS_BY_USER_FAILURE
  );
};

export const getLineGraph = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/linegraph/${queryString ? `?${queryString}` : ""}`,
    types.GET_DASHBOARD_LINEGRAPH,
    types.GET_DASHBOARD_LINEGRAPH_SUCCESS,
    types.GET_DASHBOARD_LINEGRAPH_FAILURE
  );
};

export const getHourAddonTypeSummary = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/hour-addon-type-summary/${
      queryString ? `?${queryString}` : ""
    }`,
    types.GET_HOUR_ADDON_TYPE_SUMMARY,
    types.GET_HOUR_ADDON_TYPE_SUMMARY_SUCCESS,
    types.GET_HOUR_ADDON_TYPE_SUMMARY_FAILURE
  );
};
